<div class="l-panel">
    <div class="panel-title">
        <span>{{stepNumber}}</span>
        <p>{{ 'select.meeting' | translate}}</p>
    </div>
    <div class="l-panel-ctn">
        @for (meeting of meetings; track meeting.id) {
        <div class="l-panel-item"
            matRipple 
            [matRippleCentered]="rippleOptions.centered"
            [matRippleDisabled]="rippleOptions.disabled"
            [matRippleUnbounded]="rippleOptions.unbounded"
            [matRippleRadius]="rippleOptions.radius"
            [matRippleColor]="rippleOptions.color"
            [class.selected]="meeting.id === selectedMeetingId"
            (click)="selectMeeting(meeting.id)">
            <div class="race">{{'meeting.symbol' | translate}}{{ meeting.id }}</div>
            <div class="details">
                <h2>{{ meeting.name }}</h2>
                <p>{{ meeting.races.length }} {{(meeting.races.length > 1 ? 'race.plural':'race.singular') | translate}} - {{ formateDate(meeting.date) | titlecase}}</p>
            </div>
            <div class="spec">
               <!--  @if (meeting.hasQuintePlus) {
                <img src="images/png/PMUC SG-01 1-8.png" alt="">
                }  -->
            </div>
        </div>
        }
    </div>
</div>
